import * as React from "react";
import { forwardRef } from "react";
const SvgDoing2 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m 11.840498,8.4684285 v 4.1003855 h 4.100386", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", id: "path2" }));
const ForwardRef = forwardRef(SvgDoing2);
export default ForwardRef;
